<template>
  <div id="app">
    <Background/>
    <Header/>
    <MainLayout/>
    <Footer/>
  </div>
</template>

<script>
import Background from './components/background/Background'
import MainLayout from "./components/MainLayout";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
    name: 'app',
    components: {
        Background,
        Header,
        MainLayout,
        Footer
    },
    beforeMount(){
        window.scrollTo(0,0);
    }
}
</script>

<style src="./assets/css/reset.css"></style>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Quattrocento+Sans:400,700i|Rubik:400,500i,700i');
  @import url('https://fonts.googleapis.com/css?family=Lato&display=swap');

  @import "./assets/scss/_variables.scss";

  *, *:after, *:before{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  #app {
    display: grid;
    grid-template-columns: 50vw 50vw;
    grid-template-rows: 100vh 300vh 100vh;
    /*background-color: $plainWhite;*/
    font-family: 'Rubik', sans-serif, 'Avenir', Helvetica, Arial, sans-serif;
    color: #495b69;
    text-rendering: optimizelegibility;
    overflow: hidden;
    -webkit-tap-highlight-color:rgba(0,0,0,0);
    -webkit-text-size-adjust: none;
    -webkit-font-smoothing: antialiased;
    -moz-tap-highlight-color:rgba(0,0,0,0);
    -moz-text-size-adjust: none;
    -moz-font-smoothing: antialiased;
    -ms-tap-highlight-color:rgba(0,0,0,0);
    -ms-text-size-adjust: none;
    -ms-font-smoothing: antialiased;

    @media screen and (max-width: $tabletWidth){
      grid-template-rows: 100vh 150vh;
    }
    @media screen and (max-width: $largeMobile){
      grid-template-rows: 100vh 170vh;
    }
    @media screen and (max-width: $mediumMobile){
      grid-template-rows: 100vh 210vh;
    }

  }

  // .animated { visibility: visible !important; }
</style>
